import { render, staticRenderFns } from "./CustomsDeclaration.vue?vue&type=template&id=69e24005&scoped=true&"
import script from "./CustomsDeclaration.vue?vue&type=script&lang=js&"
export * from "./CustomsDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./CustomsDeclaration.vue?vue&type=style&index=0&id=69e24005&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e24005",
  null
  
)

export default component.exports